import styled from 'styled-components';
import HotelSvg from '../../assets/verticals/hotel.svg';

const HotelIcon = styled(HotelSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4rem'};
height: ${props => props.height || '3rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default HotelIcon;
